import styled from 'styled-components';
var DetailsContainer = styled.div.attrs(function (_ref) {
  var imageWidth = _ref.imageWidth;
  return {
    style: {
      maxWidth: imageWidth
    }
  };
}).withConfig({
  displayName: "DetailsContainer",
  componentId: "sc-1ivpwg0-0"
})(["display:flex;order:", ";position:relative;width:", ";z-index:1;"], function (_ref2) {
  var alternatePosition = _ref2.alternatePosition,
      isMobile = _ref2.isMobile;
  return alternatePosition && !isMobile ? 0 : 1;
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '100%' : '50vw';
});
export default DetailsContainer;